<div class="content flex">
  <h1 class="govuk-heading-xl page-title">An unexpected error has occured. Please try again in a few minutes</h1>
  <!-- <p><a routerLink="/manage-org/profile/{{organisationId}}/registry/search">Search with a different organisation ID</a></p> -->
  <!-- <p><a (click)="goBack()">Search with a different organisation ID</a></p> -->
  <p><a href="https://www.gca.gov.uk/contact" target="_blank">Contact GCA</a></p>
  <p><a routerLink="/buyer-supplier/search">Back</a></p>
</div>
